export default {"src":"/_next/static/media/ship-skis-dark.4120a304.svg","height":524,"width":927,"blurWidth":0,"blurHeight":0};